import React from "react";
import classNames from "classnames/bind";
import s from "./Education.module.scss";
import { Typography } from "@material-ui/core";
import { getMakeStyleClasses } from "../common/getMakeStyleClasses";

const Education = (props) => {
  const classes = getMakeStyleClasses(compClasses);
  const cx = classNames.bind(classes);
  const educationDetails = props.data;

  return educationDetails.map((education, index) => {
    const { projects = [], degree, university, aggregate, year } = education;
    return (
      <section
        key={index}
        className={cx(s.container, classes.secondaryTextColor)}
      >
        <section className={cx(s.panelHeading, classes.primaryThemeColor)}>
          <Typography className={cx(classes.heading, s.heading)}>
            {degree}
          </Typography>
          <div className={cx(s.secondaryHeading, classes.secondaryHeading)}>
            <div className={s.subHeading}>
              <span>{university}</span>
              {year && <span>({year})</span>}
            </div>
            <span>{aggregate}</span>
          </div>
        </section>
        <section className={cx(classes.secondaryTextColor)}>
          {projects.map((x, index) => (
            <div key={index} className={cx(s.project, classes.project)}>
              <span className={cx(classes.secondaryTextColor, "bold")}>
                {x.title}
              </span>
              <span>{x.description}</span>
            </div>
          ))}
        </section>
      </section>
    );
  });
};

export default Education;

const compClasses = (theme) => ({
  project: {
    "&:before": {
      backgroundColor: theme.palette.text.secondary,
    },
  },
  heading: {
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  secondaryHeading: {
    color: theme.palette.text.secondary,
  },
});
